import {useCallback, useRef, useState} from 'react'
import AsyncSelect from 'react-select/async'
import {getSearchPieceTypePiece} from '../../../../components/requests'
import {formatTypePiecePourDemande} from '../../../../components/helpers'

type OptionType = {
  value: number | string
  label: string
  isDisabled?: boolean
}

const SelectPieces = ({
  onSelect,
  selectedValues = [],
}: {
  onSelect: (selected: any) => void
  selectedValues?: OptionType[]
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const loadOptions = useCallback(
    (inputValue: string, callback: (options: OptionType[]) => void) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }

      if (!inputValue) {
        callback([{value: 0, label: 'Rechercher', isDisabled: true}])
        return
      }

      setIsLoading(true)

      timeoutRef.current = setTimeout(() => {
        getSearchPieceTypePiece(inputValue)
          .then((data: any) => {
            if (data.data && data.data.length > 0) {
              const formattedData: OptionType[] = data.data.map((item) => ({
                value: item.id,
                // label: item.nom,
                label: formatTypePiecePourDemande(item)
              }))

              callback(formattedData)
            } else {
              callback([{value: 0, label: 'Aucun résultat', isDisabled: true}])
            }
          })
          .catch((error) => {
            console.error('Erreur: ', error)
            callback([])
          })
          .finally(() => {
            setIsLoading(false)
          })
      }, 700)
    },
    []
  )

  return (
    <div>
      <AsyncSelect<OptionType, true>
        isMulti
        loadOptions={loadOptions}
        isLoading={isLoading}
        placeholder='Rechercher une pièce...'
        getOptionLabel={(e) => e.label}
        getOptionValue={(e) => String(e.value)}
        noOptionsMessage={() => 'Aucune option'}
        onChange={onSelect}
        defaultValue={selectedValues}
        value={selectedValues}
      />
    </div>
  )
}

export default SelectPieces
